import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import getIconFromCategoryString from "../../Util/functions/getIconFromCategoryString";
import {
  faChevronDown,
  faChevronUp,
  faClock,
  faStar,
} from "@fortawesome/pro-regular-svg-icons";
import { faPuzzlePiece } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import formatDateString from "../../Util/functions/FormatDateString";
import formatTimeString from "../../Util/functions/FormatTimeString";
import { useContext } from "react";
import { AppContext } from "../../Util/contexts/AppContext";
import { getClientTimezoneOffset,getClientTimezoneName } from "../../Util/functions/TimeZone";
const CompletionHistoryExam = ({
  selectedCompletionIndex,
  index,
  setSelectedCompletionIndex,
  date,
  score,
  sections,
}) => {
  const { userData } = useContext(AppContext);
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = (e) => {
    e.stopPropagation();
    setIsExpanded(!isExpanded);
  };

  return (
    <div
      className={`completionHistoryExamContainer ${
        selectedCompletionIndex === index
          ? "completionHistoryContainerSelected"
          : ""
      }`}
      onClick={() => setSelectedCompletionIndex(index)}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          setSelectedCompletionIndex(index);
        }
      }}
      tabIndex={0}
    >
      <div className="completionHistoryExamBodyWrapper">
        <h3 className="completionHistoryDate">
          {formatDateString(
            date,
            userData.TimeZoneOverride
              ? getClientTimezoneName()
              : userData.TimeZone
          )}
        </h3>
        <div className="completionHistoryIconValueWrapper">
          <FontAwesomeIcon
            icon={faClock}
            className="completionsHistoryValueIcon"
          />
          <p>
            {formatTimeString(
              date,
              userData.TimeZoneOverride
                ? getClientTimezoneName()
                : userData.TimeZone
            )}
          </p>
        </div>
        <div className="completionHistoryIconValueWrapper">
          <FontAwesomeIcon
            icon={faStar}
            className="completionsHistoryValueIcon"
          />
          <p>
            {Number(score).toLocaleString(undefined, {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            })}
            %
          </p>
        </div>
      </div>
      {isExpanded && (
        <div className="completionHistoryExamSectionList">
          {sections.map((section) => (
            <div
              key={`${section.sectionId}`}
              className="completionHistoryExamSection"
            >
              <FontAwesomeIcon
                icon={getIconFromCategoryString(section.category)}
                className="completionHistoryExamSectionIcon"
              />
              <p>
                Section {section.sectionId} - {section.title}
              </p>
              <div className="completionHistoryExamSectionScoreWrapper">
                <FontAwesomeIcon
                  icon={faStar}
                  className="completionHistoryExamSectionIcon"
                />
                <p>{section.score}%</p>
              </div>
            </div>
          ))}
        </div>
      )}
      <div className="completionHistoryExamFooterContainer">
        <FontAwesomeIcon
          icon={faPuzzlePiece}
          className="completionHistoryFooterIcon"
        />
        <p>Exam Sections ({sections.length})</p>
        <button
          className="completionHistoryExamExpandButton"
          onClick={toggleExpand}
        >
          <FontAwesomeIcon icon={isExpanded ? faChevronUp : faChevronDown} />
        </button>
      </div>
    </div>
  );
};

export default CompletionHistoryExam;
